export const sequence = {
    sequence_empty_list: 'A new questionnaire will be available soon. We’ll inform you by SMS or email!',
};
